// extracted by mini-css-extract-plugin
export default {"wrap":"Picture_wrap__4y0m7","fill":"Picture_fill__s50t4","img":"Picture_img__OpR8p","contain":"Picture_contain__zVGKx","loaded":"Picture_loaded__H8bBk","zoom":"Picture_zoom__FPkdq"};